import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { ProfileProps } from '..'
import PlayerImage from '../../BaseComponents/Image/Player'
import TeamImage from '../../BaseComponents/Image/Team'

const IMAGE_DESKTOP_WIDTH = 98
const IMAGE_MOBILE_WIDTH = 62

type ProfileImageProps = ProfileProps['imageProps'] & Pick<ProfileProps, 'type'>

export const PlayerOrTeamImage: FC<ProfileImageProps & { imageWidth: number }> = ({
    type,
    imageWidth,
    ...imageProps
}) => {
    if (type === 'PERSON') {
        return <PlayerImage size="L" width={imageWidth} {...imageProps} />
    }
    return <TeamImage size="L" width={imageWidth} {...imageProps} />
}

const ProfileImage: FC<ProfileImageProps> = ({ type, ...imageProps }) => {
    const additionalWidth = type === 'TEAM' ? 2 : 0
    return (
        <>
            <Grid display={['flex', 'flex', 'none']} marginX="auto" marginBottom={3}>
                <PlayerOrTeamImage
                    type={type}
                    imageWidth={IMAGE_MOBILE_WIDTH + additionalWidth}
                    {...imageProps}
                />
            </Grid>
            <Grid display={['none', 'none', 'flex']} marginX="auto" marginBottom={3}>
                <PlayerOrTeamImage
                    type={type}
                    imageWidth={IMAGE_DESKTOP_WIDTH + additionalWidth}
                    {...imageProps}
                />
            </Grid>
        </>
    )
}

export default ProfileImage
